module.exports = __webpack_public_path__ + "media/images/application/icons/search-white-1e5fccef74fdec61db139a6f2836873d.svg";